// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const Sidebar = registerClientReference(
    function() { throw new Error("Attempted to call Sidebar() from the server but Sidebar is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/Documents/senkredi/senkredi-backoffice/components/sidebar.tsx <module evaluation>",
    "Sidebar",
);
